import * as Yup from 'yup';

export const RESPONSE = Yup.object().shape({
  slots: Yup.array().of(Yup.bool()),
  asemail: Yup.string().email()
})
export const UNKNOWN_RESPONSE = Yup.object().shape({
  asemail: Yup.string().email().required(),
  slots: Yup.array().of(Yup.bool())
})